import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { Box, Card, Grid, Stack } from '@mui/material';
import { useLocation } from 'react-router';

import { Header } from '@app/sections/header';
import { Strings } from '@app/constants';
import { useDialog, useRequestState } from '@app/hooks';
import { ProfileDetails } from '../view/profile-details';
import { AddEmployeePage } from '../view/add-employee/add-employee-page';
import { BankInfo } from '../view/bank-details';
import { Scrollbar } from '@app/components';
import { OfficialInfo } from '../view/official-info';
import { EmergencyContactInfo } from '../view/emergency-contact-info';
import { HigherEducationInfo } from '../view/higher-education-details';
import { LeaveInfo } from '../view/leave-details';
import { AssetsInfo } from '../view/assets-details';
import { ProjectsInfo } from '../view/projects-details';
import { getEmployeeActivityById, getEmployeeDetails } from '../slice';
import { selectEmployeeActivityById, selectEmployeeDetailsState } from '../selectors';
import { EmployeeDetailsList } from './employee-details-list';
import { useTable } from '@app/components/table';
import { useAuthRole } from '@app/utils';
import { WorkExperienceInfo } from '../view/work-experience-details';
import { getOverdueTasks, OverdueListPage } from '@app/modules/overdueTasks';

const EmployeeDetailsPage = () => {
  const editDialog = useDialog();
  const tableProps = useTable();
  const { isManager } = useAuthRole();

  const goBack = () => {
    history.back();
  };
  const { state } = useLocation();

  const employeeId = state.id;
  const dispatch = useDispatch();

  useEffect(() => {
    if (employeeId) {
      dispatch(getEmployeeDetails(employeeId));
      dispatch(getEmployeeActivityById(employeeId));
      dispatch(getOverdueTasks({ userId: employeeId }));
    }
  }, [employeeId, dispatch]);
  const { data } = useRequestState({
    stateSelector: selectEmployeeDetailsState,
    errorShown: true,
  });
  const { data: employeeActivity } = useRequestState({
    stateSelector: selectEmployeeActivityById,
    errorShown: true,
  });
  const user = data?.user;

  return (
    <>
      <Box sx={{ mr: 3 }}>
        <Header
          goBack={goBack}
          title={Strings.page_title.details}
          helperText={''}
          actionButtonTitle={isManager ? '' : Strings.button.EditEmployee}
          onClickActionButton={editDialog.show}
        />
      </Box>
      <Scrollbar>
        <Grid container>
          <Grid item xs={12}>
            <ProfileDetails userData={user} />
          </Grid>
          <Grid item xs={12} md={4}>
            <BankInfo userData={user} />
          </Grid>
          <Grid item xs={12} md={4}>
            <OfficialInfo userData={user} />
          </Grid>
          <Grid item xs={12} md={4}>
            <EmergencyContactInfo userData={user} />
          </Grid>
          <Grid item xs={12} md={4}>
            <WorkExperienceInfo userData={user} />
          </Grid>
          <Grid item xs={12} md={4}>
            <HigherEducationInfo userData={user} />
          </Grid>
          <Grid item xs={12} md={4}>
            <LeaveInfo userData={user} />
          </Grid>
          <Grid item xs={12} md={4}>
            <ProjectsInfo userData={data?.projectDetails} />
          </Grid>
          <Grid item xs={12} md={4}>
            <AssetsInfo userData={user} />
          </Grid>
        </Grid>
        <Stack>
          <Card sx={{ borderRadius: '5px', mx: 1, my: 2 }}>
            <OverdueListPage employeeDetails />
          </Card>
        </Stack>
        <Stack>
          <Stack fontSize={20} ml={4} fontWeight={700} mb={1}>
            Statements
          </Stack>
          <EmployeeDetailsList tableProps={tableProps} loading={false} data={employeeActivity} />
        </Stack>
      </Scrollbar>
      {editDialog.visible && (
        <AddEmployeePage row={user} open={editDialog.visible} onClose={editDialog.hide} />
      )}
    </>
  );
};
export { EmployeeDetailsPage };
